import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeoComplyStatus } from 'src/app/interfaces/geo-interface';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationErrorHandlerService {

  private error_object: BehaviorSubject<GeoComplyStatus | null> = new BehaviorSubject<GeoComplyStatus | null>(null);

  constructor() {

  }

  public getGeoComplyError(): Promise<GeoComplyStatus> {
    return new Promise((resolve) => {
      this.error_object.subscribe({
        next: (geoComplyStatus: GeoComplyStatus | null) => {
          // If no error was set yet, we resolve with a default value
          if (!geoComplyStatus) {
            console.log('************No error set yet. Returning default value************');
            resolve({
              error_code: -1,
              error_message: 'Unknown error',
              troubleshooter_message: '',
              error_details: '',
              geolocate_in: 0,
              hint: undefined,
            });
          } else {
            console.log('************Received GeoComply Error************');
            resolve(geoComplyStatus);
          }
        },
        error: (err) => {
          console.log('************Error in subscription************', err);
          resolve({
            error_code: -1,
            error_message: 'Unknown error',
            troubleshooter_message: '',
            error_details: '',
            geolocate_in: 0,
            hint: undefined,
          });
        },
        complete() {
          console.log('************Subscription completed************');
        },
      });
    });
  }


  public setGeoComplyError(error: GeoComplyStatus): void {
    console.log('************Setting GeoComply Error************');
    this.error_object.next(error);
  }
}
